export default "__VITE_ASSET__RokZQ20a__"